import { Navigate } from "react-router-dom";
import RolePage from "./RolePage";

export default [
  { path: "/role", element: <RolePage /> },
  {
    path: "/global-role",
    element: <Navigate to="/role?scope=global" replace />,
  },
  {
    path: "/client-role",
    element: <Navigate to="/role?scope=client" replace />,
  },
  {
    path: "/project-role",
    element: <Navigate to="/role?scope=project" replace />,
  },
];
